import { OtpForm } from "@modules";

export const PageOtp = () => {
  return <OtpForm />;
};
